export default __webpack_public_path__ + "b6b174d9dbcfafe8a8dc126938c1a019.png";